import type { IconData } from '@stacksjs/iconify-core'

export const recordAudio: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"6\" fill=\"currentColor\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2m0 16a6 6 0 1 1 6-6a6.007 6.007 0 0 1-6 6\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default recordAudio
